/**
 * How another surface asks the Team page to open on one of its tabs: the Hiring page's absence panel opens Call-in
 * reasons, the schedule's holiday banner opens Holidays. The tab is local state, not URL-backed filter state, so
 * Team applies the param once and strips it (`useTeamTabDeepLink`).
 */

export const TEAM_TAB_PARAM = {
	CALL_IN_REASONS: "call_in_reasons",
	HOLIDAYS: "holidays",
} as const;

export type TeamTabParam = (typeof TEAM_TAB_PARAM)[keyof typeof TEAM_TAB_PARAM];

const TEAM_TAB_REQUESTED = "true";

export function buildTeamTabUrl(departmentId: string, param: TeamTabParam): string {
	return `/${departmentId}/team?${param}=${TEAM_TAB_REQUESTED}`;
}

export function isTeamTabRequested(params: URLSearchParams, param: TeamTabParam): boolean {
	return params.get(param) === TEAM_TAB_REQUESTED;
}
